import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable,from ,switchMap} from 'rxjs';
import { StorageService } from './storage-service';
import { MyService } from './MyService';


/**
 * 身份認證服務與相關 API
 */
@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public PROFILE_VERSION: string ="hazcom_1.1";
    public constructor(
        private storageService: StorageService,
        private mySerice:MyService,
        private log: NGXLogger
    ) {

    }

    //此登入，登出狀態為，是否有用第三方登入，而非device login
    isBindingAccountSubject = new BehaviorSubject<boolean>(false);

    private async hasToken(): Promise<boolean> {

        var profile = await this.storageService.get('profile');

        return (profile != null);
    }

    /**
    *  登入使用者，並通知所有訂閱者
    */
    async login(UserProfile): Promise<void> {
        await this.setUserPrfolie(UserProfile);
    }

    /**
    * 登出使用者，並通知所有訂閱者
    */
    async logout(): Promise<void> {
        //清除第三方的登入
        var u = await this.getUserProfile();
        this.log.trace("登出前的資料", u);
        u.fackbookID = null;
        u.googleID = null;
        await this.setUserPrfolie(u);
    }

    /**
    * 是否有綁定帳號(也就是非直接uuid登入，而是有綁fb或google或帳密登入)
    * @returns {Observable<T>}
    */
    isBindingAccount(): Observable<boolean> {
        return this.isBindingAccountSubject.asObservable();
    }

    async setUserPrfolie(u: UserProfile) {
        u.version = this.PROFILE_VERSION;
        await this.storageService.set("profile", u);
        if (u.fackbookID || u.googleID ) {
            console.log("---------------------------true");
            this.isBindingAccountSubject.next(true);
        } else {
            console.log("-----------------false");
            this.isBindingAccountSubject.next(false);
        }
    }

    async getUserProfile(): Promise<UserProfile> {

        var profile = await this.storageService.get("profile");
       
        if ((!profile)||typeof (profile) != "object") {
            return null;
        } else {
            ////檢查版本規格
            if(profile.version==this.PROFILE_VERSION){
                return profile;
            }else{
                return null;
            }            
        }
    }


      /**
   * 更新 JWToken
   *
   * @param data 認證資料
   * @param data.refreshToken refresh 金鑰
   */
  public refreshJwtToken(userId) {
    console.log('Refresh jwt token');

    return from(this.getUserProfile()).pipe( 
        
        switchMap(profile => {
            console.log("profile>>>>>>>>>>>>>"+profile.refreshToken);
            return (this.mySerice.DoPostRaw('go/RefreshToken', {
                UserId:userId,
                RefreshToken: profile.refreshToken           
            }))                    
        })
    );

   // this.getUserProfile()

//     return this.mySerice.DoPost('Refresh', {
//         refreshTokenString: this.refreshTokenSubject.getValue(),
   
//     })
//       .pipe(
//         tap((tokens) => {
//           this.jwtTokenSubject.next(tokens.jwt);
//           this.refreshTokenSubject.next(tokens.refreshToken);
//           this.isLoginSubject.next(true);
//           this.storeJWToken(tokens);
//         }),
//       );
  }
}

export class UserProfile {
    version:string ;//資料版本，用在序列化還原時，用以比對格式
    userId: string; //登入的ID
    uuid:string;
    userName: string;
    fackbookID: string;
    googleID: string;
    email: string;
    accessToken: string;
    refreshToken: string;
    loginType: string;
   }